function contentScroll(id) {
    var element = document.getElementById(id);
    if (element) {
        var rect = element.getBoundingClientRect();

        var scrollPosition = window.scrollY + rect.bottom;

        window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth' 
        });
    }
}